import { render, staticRenderFns } from "./transitionservicesassessment.vue?vue&type=template&id=24fcc5c8&"
import script from "./transitionservicesassessment.vue?vue&type=script&lang=js&"
export * from "./transitionservicesassessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports